"use client";

import React from "react";
import {PageCompetitionBookTySchema} from "@/sanity/pages/PageCompetitionBookTyTemplate";

import Image from "next/image";
import Chip from "@/components/global/ui/Chip";
import BackgroundVideo from "@/components/global/utils/BackgroundVideo";
import {cn} from "@/lib/utils";
import {PortableText} from "@portabletext/react";
import {richTextComponent} from "@/sanity/sanityPortableText";
import {CTACornerButton} from "@/shadcn/ui/corner-button";

import heroGrid from "@/public/home-new/hero-grid.svg";

export default function NextSection({
  data,
  className
}: {
  data: PageCompetitionBookTySchema;
  className?: string;
}) {
  return (
    <section className={cn(
      "relative overflow-clip z-10",
      className
    )}>
      <div className="container flex flex-col items-center">
        {data?.nextTitle && (
          <div className="richtext prose-h2:text-white prose-h2:font-ivy prose-h2:italic prose-h2:pb-[4rem] lg:prose-h2:pb-[5rem]">
            <PortableText
              value={data.nextTitle}
              components={richTextComponent}
            />
          </div>
        )}

        {data?.nextText && (
          <div className="bg-[#112628] p-[3rem] w-[min(83rem,100%)] richtext prose-p:font-light prose-p:text-white/60 prose-strong:font-normal prose-strong:text-white">
            <PortableText
              value={data.nextText}
              components={richTextComponent}
            />
          </div>
        )}
      </div>
    </section>
  );
}
